import React, { useState, Fragment, useEffect } from 'react'
import { cloneDeep } from 'lodash'
import { makeStyles } from '@mui/styles'

import DocumentDetailPreview from '@/modules/document/components/edit/document-detail-preview'
import { Document } from '@/modules/document/types'

const useStyles = makeStyles(() => ({
  detailContainer: {
    maxWidth: 'calc(100vw - 350px - 100px)',
    width: '800px',
  },
}))

interface TodoFilePreviewProps {
  file: Document;
}

const TodoFilePreview: React.FC<TodoFilePreviewProps> = ({ file: initFile }) => {
  const classes = useStyles()
  const [file, setFile] = useState<Document>(cloneDeep(initFile))

  useEffect(() => {
    setFile(initFile)
  }, [initFile])

  return (
    <Fragment>
      <DocumentDetailPreview
        hideControls
        disableActions
        disableOcr
        disableDownload
        classNames={classes.detailContainer}
        file={file}
      />
    </Fragment>
  )
}

export default TodoFilePreview
